import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { NgxIcon } from '@digipay/ngx-icon';

@Component({
  selector: 'wealth-applet-wallet-diposit-hints',
  standalone: true,
  imports: [CommonModule, NgxIcon],
  templateUrl: './wallet-diposit-hints.component.html',
  styleUrl: './wallet-diposit-hints.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletDipositHintsComponent implements OnInit {
  stepItems: string[] = [];
  bannerUrl = input<string>();
  dailyPercentage = input<string>();
  walletTitle = input<string>();
  supportNumber = signal<string>('021-53924000');

  ngOnInit(): void {
    this.stepItems = [
      `با واریز پول به ${this.walletTitle()}، <span class="st-7 text-onback-high">${this.dailyPercentage()} </span> سود سالانه به صورت روز شمار به موجودیتان تعلق می‌گیرد.`,
      'برداشت از ' + this.walletTitle() + ' حداکثر ۱ روز کاری بعد از ثبت درخواست برداشت، انجام خواهد شد.',
      `در صورت نداشتن بدهی و یا اعتبار سازمانی فعال، به پشتوانه موجودیتان و مسدود کردن آن می\u200Cتوانید اعتبار خرید ۴ قسطه دریافت کنید. حداقل موجودی برای درخواست اعتبار باید<span class="c-1 text-onback-high">۳ میلیون تومان</span> باشد.`,
      'به موجودی مسدود شده نیز سود تعلق می‌گیرد.',
      'درصورت خرج نکردن اعتبار، امکان لغو آن و آزاد شدن مبلغ مسدود شده  وجود دارد.',
      ' بعد از پرداخت تمام اقساط، این مبلغ آزاد شده و می\u200Cتوانید نسبت به برداشت وجه و یا دریافت دوباره اعتبار اقدام کنید.',
      'در صورت عدم پرداخت قسط تا روز پنجم هر ماه، این مبلغ از موجودی غیر قابل برداشت شما کسر خواهد شد.',
    ];
  }
}
